import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListAlt } from "@fortawesome/free-solid-svg-icons";
import MainLayout from '../../layouts/MainLayout';
import "../../styles/ChangePassword.css";

const PasswordHintQuestions = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState([
    { q: '', a: '' },
    { q: '', a: '' },
    { q: '', a: '' },
    { q: '', a: '' },
    { q: '', a: '' }
  ]);

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  
  useEffect(() => {
    const fetchHintQuestions = async () => {
      const config = {
        url: "/myprofile/gethintquestions",
        method: "post",
        data: { userId: authState.user._id },
        headers: { Authorization: authState.token }
      };
  
      try {
        const response = await fetchData(config);
        // console.log("Response:", response);
        // console.log("Response 111:", response.status);

        if (response && response.status) {
          // console.log("Response Data:", response.hintQuestions);
          
          const hintQuestions = response.hintQuestions.hintQuestions;
          // console.log("Setting formData:", hintQuestions);

          setFormData(hintQuestions);

        } else {
          setMessage("Hint Questions not received! Please try again.");
        }
      } catch (error) {
        console.error('Error getting Hint Questions:', error);
        setMessage("Error fetching Hint Questions. Please try again.");
      }
    };
  
    fetchHintQuestions();
  }, [authState.user._id, authState.token, fetchData]);

  // Handle form submission
  const handleUpdateHintQuestions = async () => {
    const config = {
      url: "/myprofile/updatehintquestions",
      method: "post",
      data: { hintQuestions: formData, userId: authState.user._id },
      headers: { Authorization: authState.token }
    };

    try {
      const response = await fetchData(config);
      if (response.data.status) {
        setMessage("Hint Questions updated successfully!");
      } else {
        setMessage("Failed to update Hint Questions! Please try again.");
      }
    } catch (error) {
      console.error('Error updating Hint Questions:', error);
      setMessage("Error updating Hint Questions. Please try again.");
    }
  };

  const handleBackButton = () => {
    navigate("/my-profile-home");
  };

  const hintQuestionsList = [
    "What was the name of your first pet?",
    "What is your favorite book or author?",
    "What city were you born in?",
    "What was the name of your first school?",
    "What is your mother’s maiden name?",
    "What was the make and model of your first car?",
    "What is your favorite childhood memory?",
    "What is the name of the street you grew up on?",
    "What was the first concert you attended?",
    "What is your favorite movie or TV show?",
    "I have my own answer without a question"
  ];

  // const handlePickQuestion = (index) => {
  //   const newFormData = [...formData];
  //   newFormData[index].showSelect = !newFormData[index].showSelect;
  //   setFormData(newFormData);
  // };
  
  // const handleSelectQuestion = (index, selectedQuestion) => {
  //   const newFormData = [...formData];
  //   newFormData[index].q = selectedQuestion;
  //   newFormData[index].showSelect = false; 
  //   setFormData(newFormData);
  // };

  const handlePickQuestion = (index) => {
    setCurrentIndex(index);
    setOverlayVisible(true);
  };

  const handleSelectQuestion = (selectedQuestion) => {
    const newFormData = [...formData];
    newFormData[currentIndex].q = selectedQuestion;
    newFormData[currentIndex].showSelect = false;
    setFormData(newFormData);
    setOverlayVisible(false); 
  };

  const handleInputChange = (index, field, value) => {
    const newFormData = [...formData];
    newFormData[index][field] = value;
    setFormData(newFormData);
  };

  return (
    <MainLayout>
      <div className="bg-gray-800 text-white py-4 px-4 mb-4 mt-12">
        <h3 className="text-2xl font-semibold px-4 mb-2">
          Update Hint Questions
        </h3>
      {/* </div>
      <div className="container min-h-[200vh] py-4 bg-gray-700 shadow-lg rounded-lg flex flex-col"> */}
        <form>
          {formData.map((item, index) => (
            <div key={index} className="mt-4 border-container space-y-2 relative border border-gray-300 rounded-lg p-4">
              
              <div className="flex flex-row ">
                <label className="block text-white font-medium  h-12 mr-4 py-2">{`Question ${index + 1}:`}</label>
                <input
                  className="h-12 px-2 py-2 text-black border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  type="text"
                  value={item.q}
                  onChange={(e) => handleInputChange(index, 'q', e.target.value)}
                  placeholder={`Enter question ${index + 1}`}
                />
                <button
                  type="button"
                  className=" h-12 w-10 py-2 ml-2 text-white cursor-pointer"
                  onClick={() => handlePickQuestion(index)}
                  title="Pick from the list"
                >
                  <FontAwesomeIcon icon={faListAlt} />
                </button>
              </div>
              <div className="flex flex-row">
                <label className="text-white  h-12 font-medium mr-4 py-2">{`Answer ${index + 1}     :`}</label>
                <input
                  className="w-full text-black h-12 px-2 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  type="text"
                  value={item.a}
                  onChange={(e) => handleInputChange(index, 'a', e.target.value)}
                  placeholder={`Enter answer ${index + 1}`}
                />
              </div>
            </div>
          ))}

          {overlayVisible && (
            <div className="mt-12 min-h-[100vh] fixed inset-20 bg-black bg-opacity-50 flex">
              <div className="bg-gray-600 p-6 rounded-lg shadow-lg w-200">
                <h3 className="text-lg font-semibold mb-4 text-yellow-200">Select a Question</h3>
                <ul> 
                  {hintQuestionsList.map((question, i) => (
                    <li
                      key={i}
                      className="cursor-pointer p-2 hover:bg-gray-500"
                      onClick={() => handleSelectQuestion(question)}
                    >
                      {question}
                    </li>
                  ))}
                </ul>
                <button
                  className="mt-4 px-4 py-2 bg-red-600 text-black rounded-md"
                  onClick={() => setOverlayVisible(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          <div className="flex flex-row justify-center mt-4">
            <button
              type="button"
              className={`w-40 px-4 py-2 text-white bg-blue-600 rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={handleUpdateHintQuestions}
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Update'}
            </button>
            <button
              type="button"
              className={`ml-4 w-40 px-4 py-2 text-white bg-blue-600 rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={handleBackButton}
            >
              Back
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default PasswordHintQuestions;
